import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { tzmoment } from 'lib/tzmoment';
import { PortCall } from 'data/models/PortCall';
import { Issue } from 'data/models/Issue';
import { IssueCountBadge } from 'portcall/issues/view';
import { PCBadge } from 'portcall/pcbadge/view';
import { PCTooltip } from 'portcall/pctooltip/view';

export const PortCallHeaderView = SuperCritical(({ portcall: pc, canEdit, issues, onIssueBadgeClick } : {
    portcall : PortCall,
    canEdit : () => boolean,
    // TH 12/06/2016 -- For now, making issue badge optional for the benefit of the topiccards page.
    // Talked w/ DC and depends on whether we decide to include the IssuesModal on that page.
    issues? : () => Issue[],
    onIssueBadgeClick? : () => void
}) => {
    let brs = pc.ActiveReservations(),
        durationMonths = "",
        durationDays = "",
        pjos = pc.JobOrders(),
        rafting = brs.some(br => br.Rafting()),
        hasPilotOrders = pjos.length > 0;
    
    if (brs.length > 0) {
        let firstLine = tzmoment(brs[0].Itinerary()!.Arrival.Effective()),
            lastLine = tzmoment(brs[brs.length - 1].Itinerary()!.Departure.Effective());
    
        durationMonths = firstLine.format("MMM");
        if (lastLine.format("MMM") != durationMonths)
            durationMonths += " - " + lastLine.format("MMM");
        durationDays = firstLine.format("DD");
        if (lastLine.format("MMM") != durationMonths || lastLine.format("DD") != durationDays)
            durationDays += " - " + lastLine.format("DD");
    }

    return (
        <div className="portcall-header">
            <div className="pc-card pc-card-pcprofile header-timestamp">
                <div className="month">{durationMonths}</div>
                <div className="days">{durationDays}</div>
            </div>
            <div className="header-text">
                <div className="pc-page-title portcall-title">{pc.DisplayVesselIdentifier() + ' PortCall'}</div>
                <div className="portcall-subtitle">
                    <span className="pc-text-smalllabel">Requested by </span>
                    <span className="pc-text-smalltext">{pc.Requestor() ? pc.Requestor()!.FullName() : ''}</span><span className="pc-icon-bullet"></span>
                    <span className="pc-text-smalllabel">Voyage # </span>
                    <span className="pc-text-smalltext" hidden={canEdit()}>{pc.VoyageNumber()}</span>
                    <input type="text" className="pc-text-smalltext" hidden={!canEdit()}
                        value={pc.VoyageNumber() || ''}
                        onChange={e => pc.VoyageNumber(e.currentTarget.value)} />
                </div>
            </div>
            <div className="header-icons">
                <PCTooltip title={() => 'This PortCall has pilotage ordered. Please review the Dispatch Dashboard for additional information.'}
                           className={'badge-tooltip'}>
                    <PCBadge className="pilotage-badge" visible={hasPilotOrders}>P</PCBadge>
                </PCTooltip>
                <PCTooltip title={() => 'This PortCall is Unlisted. It can only be viewed by people associated with the PortCall. Only authorized users can list it.'}
                           className={'badge-tooltip'}>
                    <PCBadge className="unlisted-badge" visible={pc.Unlisted()}>U</PCBadge>
                </PCTooltip>
                <PCTooltip title={() => 'This PortCall has a rafted reservation. Go to the Berths Timeline to view the vessel this is rafted to.'}
                           className={'badge-tooltip'}>
                    <PCBadge className="rafting-badge" visible={rafting}>R</PCBadge>
                </PCTooltip>
                <PCTooltip title={() => 'Click this badge to view more details behind the conflicts in this PortCall.'}
                           className={'badge-tooltip'}>
                    {issues && <IssueCountBadge issues={issues} onClick={onIssueBadgeClick} />}
                </PCTooltip>
            </div>
        </div>
    );
});


// WEBPACK FOOTER //
// ./apps/portcall/portcallprofile/portcallheaderview.tsx